import { Directive, HostBinding, HostListener, Input, OnInit } from "@angular/core";

@Directive({
    selector: "[calculated-height]",
})
export class CalculatedHeightDirective implements OnInit {
    @Input("calculatedHeightOffset")
    public offset = 0;

    public isOverriden = false;

    @Input()
    public set heightOverride(value: number) {
        if (value) {
            this.containerHeight = value;
            this.isOverriden = true;
            this.setContainerHeight();
        }
    }

    @HostBinding("style.height.px")
    public containerHeight: number;

    public ngOnInit(): void {
        this.setContainerHeight();
    }

    @HostListener("window:resize")
    public setContainerHeight(): void {
        if (!this.isOverriden) {
            this.containerHeight = window.innerHeight - this.offset;
        }
    }
}
